/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useMemo } from 'react'
import { utilityHeader, YNBooleanTypes } from 'core/HeaderColTypeProps'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  getDartReconciliation,
  submitDartReconciliation,
  ignoreDartReconciliation,
} from 'api/pgads'
import { connect } from 'react-redux'
import { getApiTargetInfo, getUnitNameMap, getUtilityNameMap } from 'core'
import { ErrorContext } from 'context'
import CommonScreen from 'admin/component/CommonScreen'
import { Button } from 'antd'

const headers = [
  strCol({
    ident: 'enableAction',
    display: 'Select Records',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  utilityHeader,
  strCol({ ident: 'unitName', display: 'Unit Name', isKey: true, width: 200 }),
  strCol({ ident: 'dartUnitId', display: 'eDart ID', isKey: true, width: 200 }),

  // unitHeader,
  strCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 200,
  }),
  numCol({
    ident: 'gadsEventNum',
    display: 'GADS Event Number',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'eventtype',
    display: 'Event Type',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'dartEventtype',
    display: 'eDart Event Type',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'actualEventstart',
    display: 'Actual Event Start',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'actualEventend',
    display: 'Actual Event End',
    isFiltered: true,
    width: 200,
  }),

  strCol({
    ident: 'pjmTicketId',
    display: 'PJM Ticket ID',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'ticketStatus',
    display: 'Ticket Status',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'installCapred',
    display: 'MW Reduction',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'availCap',
    display: 'Available Capacity',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isFiltered: true,
    width: 500,
    alignment: 'left',
    ellipsis: true,
  }),
  // modifierCol,
  // modifiedDateCol,
]
const title = 'Dart Reconciliation'

const DartReconciliation = ({ targetInfo, unitNameMap, utilityNameMap }) => {
  const { setError } = useContext(ErrorContext)

  const withCriteria = (state, props, selectedUnits) => ({
    units: (selectedUnits || []).filter(e => !!e).map(e => e.unitId),
  })

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header.ident === 'utility'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header
      ),
    [unitNameMap, utilityNameMap]
  )

  const extraCriteriaAfterButton = ({ onRetrieve, editInfo }) => {
    const applicableRows = (editInfo.updated || []).filter(
      e => e.enableAction === 'Y'
    )
    return (
      <>
        <Button
          type="primary"
          icon="edit"
          disabled={applicableRows.length <= 0}
          onClick={_ =>
            submitDartReconciliation(targetInfo)(applicableRows).fork(
              setError,
              _ => {
                onRetrieve()
              }
            )
          }
        >
          Submit to GADS
        </Button>
        <Button
          // type="primary"
          icon="edit"
          disabled={applicableRows.length <= 0}
          onClick={_ =>
            ignoreDartReconciliation(targetInfo)(applicableRows).fork(
              setError,
              _ => {
                onRetrieve()
              }
            )
          }
          style={{ marginLeft: '10px' }}
        >
          Ignore Ticket(s)
        </Button>
      </>
    )
  }

  const sortOnData = data => {
    return data.map(d => ({ ...d, enableAction: 'N' }))
  }
  return (
    <CommonScreen
      sortOnData={sortOnData}
      withoutModify
      withUnitSelection={false}
      autoRetrieve
      allowInsert={false}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getDartReconciliation}
      withCriteria={withCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      altBy={u => u.unitId}
      // sortOptions={headerWithFormatter}
      // initialSortOptions={headerWithFormatter}
      widthOffset={50}
      isEditableGrid={({ header }) => header.ident === 'enableAction'}
      isAdminScreen={false}
      sortEnabled={false}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(DartReconciliation)
